<template>
  <BaseButton
    :rate="rate"
    :game-name="name"
    :result-type="$t('total_and_double')"
    :result="$t('baccarat.DUAL_ANY')"
    :table="table"
    :round="round"
    :data="data"
    css="right"
    bet-type="NUM_5"
    :is-highlight="isHighlightResult && isSelected"
    :current-chip="currentChip"
    :game-state="gameState"
    :is-show-rate="false"
  >
    <div class="playbox-option">
      <div
        class="playbox-option-name playbox-option-fontType2"
        :class="classObject"
      >
        {{ $t('baccarat.DUAL_ANY') }}
      </div>
    </div>
  </BaseButton>
</template>

<script>
import BaseButton from '@/src/components/taixiu/buttons/base-button.vue';
import { GAMESTATE } from '@config/constants.js';

export default {
  components: {
    BaseButton,
  },
  props: {
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    round: { type: Number, default: 0 },
    score: { type: Object, default: () => ({})},
    data: { type: Object, default: () => ({})},
    rate: { type: Number, default: 0 },
    isHighlightResult: Boolean,
    currentChip: { type: Number, default: 0 },
    gameState: {
      type: String,
      default: GAMESTATE.WAITING_NEW_GAME,
    },
  },
  computed: {
    isSelected: function () {
      return this.score && this.score.resultType && this.score.resultType.includes('NUM_5')
    },
    classObject: function () {
      return {
        'playbox-highlight-text-color': this.isSelected
      }
    }
  },
}
</script>

<style>

</style>
